import React from "react";
import ReactLoading from "react-loading";
import "./SpinnersLoadingSIP.css";
import logo from "../../assets/images/Sharjah/loaderLogoS.png";

function SpinnersLoadingSIP() {
  return (
    <div className="loader-container">
      <ReactLoading
        type={"spinningBubbles"}
        color={"#FAA634"}
        height={150}
        width={150}
        className="spinningBubblesClass"
      />
      <div className="logo-container">
        {/* <img src={logo} alt="Logo" className="logo" /> */}
      </div>
    </div>
  );
}

export default SpinnersLoadingSIP;
